import { Injectable } from '@angular/core';

import { ConfigService } from '../../../../core';
import { PessoaTermoLGPD } from '../pessoa-termo-lgpd';
import { isPessoaTermoLGPDStatusPendente, isPessoaTermoLGPDStatusImpresso, isPessoaTermoLGPDStatusAnexado } from '../status/pessoa-termo-lgpd-status';

@Injectable({
    providedIn: 'root'
})
export class PessoaTermoLGPDAuthGuardService {

    constructor(private configService: ConfigService) { }

    /** Verifica se a empresa possui o Termo LGPD ativo nas suas configurações */
    private possuiTermoLGPD(): boolean {
        return this.configService.getEmpresa()?.possuiTermoLGPD;
    }

    /** Verifica se pode imprimir o termo LGPD */
    canImprimir(entity: PessoaTermoLGPD): boolean {
        // Empresa não possui Termo LGPD
        if (!this.possuiTermoLGPD) {
            return false;
        }
        // Termo LGPD não informado
        if (!entity) {
            return false;
        }
        return isPessoaTermoLGPDStatusPendente(entity.status) || isPessoaTermoLGPDStatusImpresso(entity.status);
    }

    /** Verifica se pode imprimir o termo LGPD novamente */
    canImprimirNovamente(entity: PessoaTermoLGPD): boolean {
        // Empresa não possui Termo LGPD
        if (!this.possuiTermoLGPD) {
            return false;
        }
        // Termo LGPD não informado
        if (!entity) {
            return false;
        }
        // Não pode imprimir
        if (!this.canImprimir(entity)) {
            return false;
        }
        // Somente se já tiver o usuário que realizou a primeira impressão
        return entity.idUsuarioImpressao != null && entity.idUsuarioImpressao !== undefined;
    }

    /** Verifica se pode anexar o termo LGPD */
    canAnexar(entity: PessoaTermoLGPD): boolean {
        // Empresa não possui Termo LGPD
        if (!this.possuiTermoLGPD) {
            return false;
        }
        // Termo LGPD não informado
        if (!entity) {
            return false;
        }
        return isPessoaTermoLGPDStatusImpresso(entity.status);
    }

    /** Verifica se pode abrir o anexo o termo LGPD */
    canOpenAnexo(entity: PessoaTermoLGPD): boolean {
        // Empresa não possui Termo LGPD
        if (!this.possuiTermoLGPD) {
            return false;
        }
        // Termo LGPD não informado
        if (!entity) {
            return false;
        }
        return isPessoaTermoLGPDStatusAnexado(entity.status);
    }

    /** Verifica se pode excluir do termo LGPD */
    canDelete(entity: PessoaTermoLGPD): boolean {
        // Empresa não possui Termo LGPD
        if (!this.possuiTermoLGPD) {
            return false;
        }
        // Termo LGPD não informado
        if (!entity) {
            return false;
        }
        return isPessoaTermoLGPDStatusAnexado(entity.status);
    }
}
